import { useState, useEffect } from 'react';
import useDataBean from '../../../../core/services/dataBean/useDataBean';
import { _SocialSecuritySpreadSheet } from '../../../../core/services/dataBean/EntityCatalogVdos';
import useModal, { MODAL_md } from '../../../theme/Component/hooks/useModal';
import { BasicTable, MASK_NUMBER } from '../../../theme/Component/BasicTable';
import { Modal } from '../../../theme/Component/Modal';
import { toast } from 'react-toastify';
import { AccountantYear } from '../../GestionTH/EmployeeContract/ProductionPlan/AccountantYear';
import { MonthEditorbyconst } from '../../../RemoteAbstractAction/editors/MonthEditorbyconst';
import { BasicButton } from '../../../theme/Component/BasicButton';
import { _single } from '../../../../core/services/dataBean/EntityCatalog';


interface Props {
    idSelector: number;
    onChange: any;
    label?: string;
    returnType?: "ID" | "Object";
    render?: string;
}

export const SocialSecuritySpreadSheetEditor = ({ idSelector, onChange, label, returnType = "ID", render }: Props) => {

    const { instance, lista, setLista } = useDataBean(_SocialSecuritySpreadSheet)
    const [id, setID] = useState(null);
    const [month, setMonth] = useState<any>(null);
    const [regexStr, setregexStr] = useState<any>(null);
    const [year, setYear] = useState<any>(_single.getCurrenYear());
    const modal = useModal("Planilla Padre", MODAL_md);

    useEffect(() => {
        setID(idSelector)
    }, [idSelector])

    useEffect(() => {
        getLista();
    }, [])

    const setValue = (e: string) => {
        const selectedId = parseInt(e);
        setID(selectedId);
        if (onChange) {
            const selectedItem = lista.find(
                (item) => item?.DataBeanProperties?.IDSocialSecuritySpreadSheet == e
            );
            if (selectedItem) {
                onChange(returnType === "Object" ? selectedItem?.DataBeanProperties : selectedId);
            } else {
                onChange(returnType === "Object" ? {} : null);
            }
        }
    };


    const getLista = () => {
        instance.getSocialSecuritySpreadSheetCatalog(year, month, regexStr).then(
            (resp: any) => {
                if (resp) {
                    resp.forEach(element => {
                        const spread = element.DataBeanProperties;
                        spread.DocumnetEntity = spread.IDDocument ? `${spread.Mnemonic} ${spread.IDDocument} ${spread.DocumentDate}` : "N/P"

                    });
                    setLista(resp)
                }
            }
        ).catch(err => { toast.error(err) })

    }
    const head = [
        { title: 'ID', property: 'IDSocialSecuritySpreadSheet', visible: true },
        { title: 'Tipo', property: 'TypeName', visible: true },
        { title: 'Año', property: 'Year', visible: true },
        { title: 'Mes', property: 'MonthName', visible: true },
        { title: 'Nombre', property: 'Name', visible: true },
        { title: 'Usuario', property: 'EmployeeName', visible: true },
        { title: 'Creado', property: 'Since', visible: true },
        { title: 'Documento de Ajuste', property: 'DocumnetEntity', visible: true },
    ]
    const abrirModal = () => {
        modal.open();
    }


    return (
        <>
            <label>{label ?? "Planilla"}</label>
            <span className='form-control cursor ifmodal' onClick={abrirModal}>{render ?? ''}</span>
            <Modal modal={modal.modal} updateModal={modal.setModal}>
                <div className="row">
                    <div className="col-md-6">
                        <AccountantYear label='Vigencia' idSelector={year} onChange={(e) => { setYear(e) }} />
                    </div>
                    <div className="col-md-6">
                        <MonthEditorbyconst idSelector={month} onChange={(e) => { setMonth(e) }} />
                    </div>
                    <div className="col-md-6">
                        <label>Búsqueda por Texto</label>
                        <input type="text" name="regexStr" className="form-control" value={regexStr} onChange={(e) => { setregexStr(e.target.value) }} />
                    </div>
                    <div className="col-md-6 mt-4 p-2">
                        <BasicButton icon="ri-align-justify" eventClick={getLista}>Buscar</BasicButton>
                    </div>
                </div>
                <BasicTable head={head} body={lista} rowSet={(e) => { setValue(e.IDSocialSecuritySpreadSheet); modal.close(); }}></BasicTable>
            </Modal>
        </>
    )
}